import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const StaffManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [message, setMessage] = useState("");

  const [leader, setLeader] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [telegram, setTelegram] = useState("");

  useEffect(() => {
    fetchStaffFromDatabase();
  }, []);

  const fetchStaffFromDatabase = async () => {
    try {
      const response = await fetch("https://api.backofficemain.com/get_staff.php");
      const data = await response.json();
      if (data.success) {
        // ✅ Sembunyikan staff dengan role master
        const filtered = data.staff.filter((s) => s.jabatan !== "master");
        setStaffList(filtered);
      } else console.error("Failed to load staff:", data.message);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  const resetForm = () => {
    setUsername("");
    setPassword("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setWhatsapp("");
    setTelegram("");
    setLeader(false);
    setEditMode(false);
  };

  const generateRandomCode = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < 8; i++)
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    return code;
  };

  const handleSaveStaff = async (e) => {
    e.preventDefault();
    const jabatan = leader ? "leader" : "staff";

    if (!editMode) {
      const duplicate = staffList.find(
        (s) => s.username.toLowerCase() === username.toLowerCase()
      );
      if (duplicate) {
        setMessage("⚠️ Username already exists!");
        return;
      }
    }

    const formData = new FormData();
    formData.append("jabatan", jabatan);
    formData.append("username", username);
    formData.append("password", password);
    formData.append("firstname", firstName);
    formData.append("lastname", lastName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("whatsapp", whatsapp);
    formData.append("telegram", telegram);
    if (!editMode) formData.append("code", generateRandomCode());

    try {
      const url = editMode
        ? "https://api.backofficemain.com/update_staff.php"
        : "https://api.backofficemain.com/add_staff.php";
      const response = await fetch(url, { method: "POST", body: formData });
      const data = await response.json();
      if (data.success) {
        setMessage(editMode ? "✅ Staff updated!" : "✅ Staff added!");
        setShowModal(false);
        resetForm();
        fetchStaffFromDatabase();
      } else setMessage("❌ Failed: " + data.message);
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Server error while saving staff.");
    }
  };

  const handleEditStaff = (staff) => {
    if (staff.jabatan === "master") return; // ✅ Tidak bisa edit master
    setUsername(staff.username);
    setPassword("");
    setFirstName(staff.firstname);
    setLastName(staff.lastname);
    setEmail(staff.email);
    setPhone(staff.phone);
    setWhatsapp(staff.whatsapp);
    setTelegram(staff.telegram);
    setLeader(staff.jabatan === "leader");
    setEditMode(true);
    setShowModal(true);
  };

  const handleDeleteStaff = async (username, jabatan) => {
    if (jabatan === "master") return; // ✅ Tidak bisa hapus master
    if (!window.confirm(`Delete staff "${username}"?`)) return;
    try {
      const response = await fetch("https://api.backofficemain.com/delete_staff.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      if (data.success) {
        setMessage("🗑️ Staff deleted successfully!");
        fetchStaffFromDatabase();
      } else setMessage("❌ Failed to delete: " + data.message);
    } catch {
      setMessage("⚠️ Server error while deleting.");
    }
  };

  const filteredStaff = staffList.filter(
    (s) =>
      s.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.firstname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.lastname?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mt-4" style={{ maxWidth: "1100px" }}>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h3 className="fw-bold text-primary mb-2">Staff Management</h3>
        <div className="d-flex gap-2 align-items-center">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search staff..."
            style={{ width: "220px" }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
          >
            + Add Staff
          </button>
        </div>
      </div>

      {message && (
        <div className="alert alert-info py-2 text-center" role="alert">
          {message}
        </div>
      )}

      <div className="card shadow-sm">
        <div className="card-body p-0">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="text-start ps-4">Username</th>
                <th className="text-start">Name</th>
                <th className="text-start">Role</th>
                <th className="text-start" style={{ width: "150px" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredStaff.length > 0 ? (
                filteredStaff.map((s, i) => (
                  <tr key={i}>
                    <td className="ps-4">{s.username}</td>
                    <td>{`${s.firstname} ${s.lastname}`}</td>
                    <td>
                      <span
                        className={`badge ${
                          s.jabatan === "leader"
                            ? "bg-success"
                            : "bg-secondary"
                        }`}
                      >
                        {s.jabatan}
                      </span>
                    </td>
                    <td>
                      <div className="btn-group">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleEditStaff(s)}
                          disabled={s.jabatan === "master"} // ✅ tombol edit off
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() =>
                            handleDeleteStaff(s.username, s.jabatan)
                          }
                          disabled={s.jabatan === "master"} // ✅ tombol delete off
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-3">
                    No staff found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Form */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header bg-primary text-white py-2">
                <h5 className="modal-title mb-0">
                  {editMode ? "Edit Staff" : "Add New Staff"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSaveStaff}>
                  <div className="row g-2">
                    <div className="col-md-6">
                      <label className="form-label mb-1">Username</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        disabled={editMode}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label mb-1">Password</label>
                      <input
                        type="password"
                        className="form-control form-control-sm"
                        placeholder={editMode ? "Leave blank" : ""}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label mb-1">First Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label mb-1">Last Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label mb-1">Email</label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label mb-1">Phone</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label mb-1">WhatsApp</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label mb-1">Telegram</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={telegram}
                        onChange={(e) => setTelegram(e.target.value)}
                      />
                    </div>

                    <div className="col-12 d-flex justify-content-end align-items-center mt-3">
                      <label
                        htmlFor="isLeaderCheck"
                        className="form-check-label me-2 mb-0"
                      >
                        Is Leader?
                      </label>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ width: "16px", height: "16px" }}
                        checked={leader}
                        onChange={() => setLeader(!leader)}
                        id="isLeaderCheck"
                      />
                    </div>
                  </div>

                  <div className="mt-4 text-end">
                    <button type="submit" className="btn btn-success btn-sm me-2">
                      {editMode ? "Update" : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffManagement;
